import { atomWithStorage, useAtom } from "@mdotm/shadcn/legacy/reactivity";
import type { Updater } from "@mdotm/shadcn/legacy/utils";

export const InstrumentPool = {
	mdotm: "MDOTM",
	instrumentCustomisation: "INSTRUMENT_CUSTOMISATION",
} as const;

export type InstrumentPool = (typeof InstrumentPool)[keyof typeof InstrumentPool];

export type InstrumentAdderStoreProps = {
	expand: boolean;
	instrumentPool: InstrumentPool;
};

export const instrumentAdderDefault: InstrumentAdderStoreProps = {
	expand: true,
	instrumentPool: InstrumentPool.mdotm,
};

export const instrumentAdder$ = atomWithStorage<InstrumentAdderStoreProps>(
	"instrumentAdderAtom",
	instrumentAdderDefault,
);

export function useInstrumentAdderState(): {
	instrumentAdderStore: InstrumentAdderStoreProps;
	setInstrumentAdderStore: (newValue: InstrumentAdderStoreProps | Updater<InstrumentAdderStoreProps>) => void;
	reset(): void;
} {
	const [instrumentAdderStore, setInstrumentAdderStore] = useAtom(instrumentAdder$);
	return {
		instrumentAdderStore,
		setInstrumentAdderStore,
		reset: () => setInstrumentAdderStore(instrumentAdderDefault),
	};
}
